import { Autocomplete as MuiAutocomplete, TextField } from '@mui/material';
import type { AutocompleteProps as MuiAutocompleteProps } from '@mui/material';
import type { FC } from 'react';
import React from 'react';

import Icon from '@components/Icon/Icon';

type AutocompleteOption = { id: string; name: string };

interface AutocompleteProps {
  options: AutocompleteOption[];
  onChange?: (option: AutocompleteOption | null) => void;
  loading?: boolean;
}

const Autocomplete: FC<AutocompleteProps> = ({
  options,
  onChange,
  loading = false,
}) => {
  const sortedOptions = React.useMemo(() => {
    return options.sort((a, b) => a.name.localeCompare(b.name));
  }, [options]);

  const handleChange: MuiAutocompleteProps<
    AutocompleteOption,
    false,
    false,
    false
  >['onChange'] = (_event, value) => {
    onChange?.(value);
  };

  return (
    <MuiAutocomplete
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      loading={loading}
      onChange={handleChange}
      options={sortedOptions}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <Icon color="inherit" spin name="spinner-third" type="fad" />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{ padding: 1 }}
          variant="outlined"
        />
      )}
    />
  );
};

export default Autocomplete;
